import React from 'react';
import PropTypes from 'prop-types';
import Hyperlink from '../../components/hyperlink';
import Wrapper from '../../components/wrapper';
import './styles.css';

/**
 * FooterNavigation
 */
const FooterNavigation = ({
                            containerId,
                            containerClass,
                            copyright,
                            links,
                          }) => {
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <div className="FooterNavigation">
        <div className="FooterNavigation__container">
          <div className="FooterNavigation__layout">
            <div className="FooterNavigation__layout-left">
              <ul className="FooterNavigation__list">
                {(links !== null) ?
                  links.map((link, index) => {
                    return (
                      <li className="FooterNavigation__list-item"
                          key={index}
                      >
                        <Hyperlink
                          pageName={link.pageName}
                          pcText={link.pcText}
                          mbText={link.mbText}
                          href={link.href}
                          external={link.external}
                        />
                      </li>
                    )
                  })
                  : null}
              </ul>
            </div>
            <div className="FooterNavigation__layout-right">
              {(copyright !== null) ?
                <small className="FooterNavigation__copyright Wysiwyg">
                  <div dangerouslySetInnerHTML={{__html: copyright}}/>
                </small>
                : null}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
};

FooterNavigation.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  copyright: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    pageName: PropTypes.string,
    pcText: PropTypes.string,
    mbText: PropTypes.string,
    href: PropTypes.string,
    external: PropTypes.bool,
  })),
};
FooterNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  copyright: null,
  links: null,
};
export default FooterNavigation;



// WEBPACK FOOTER //
// ./src/containers/footer-navigation/index.jsx